<template>
  <div class="container auth-forms">
    <div class="columns">
      <div class="column">
        <LoginForm/>
      </div>
      <div class="column">
        <RegisterForm/>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm'
import RegisterForm from '@/components/RegisterForm'
export default {
  components: {
    LoginForm,
    RegisterForm
  }
}
</script>

<style scoped>
  .auth-forms {
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageAuth.vue